import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


export interface EditStoryComponent {
  canDeactivate(): Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class EditChangesGuard implements CanDeactivate<EditStoryComponent> {

  constructor() { }

  canDeactivate(
    component: EditStoryComponent
  ): Observable<boolean> | boolean {
    if (component.canDeactivate) {
      return component.canDeactivate();
    } else {
      return false;
    }
  }
}
